// extracted by mini-css-extract-plugin
module.exports = {"dateContainer":"CreditCardExpiryDate_dateContainer__2_LW2","date":"CreditCardExpiryDate_date__1RyvW"};